module.exports = __webpack_public_path__ + "img/advantage4.f45d6b17.png";